import React from 'react';

import { useFlag } from 'jsx/utils/featureFlagsAndMetrics';
import CONFIG from 'jsx/constants/config';
import { useOfferCategory } from 'jsx/utils/hooks/useOfferCategory';
import { OFFER_CATEGORIES } from 'jsx/api/generated';

import { sunscreenGiveawayBannerStyles } from './style';

const SunscreenGiveawayBanner = () => {
  const offerCategory = useOfferCategory();

  const showSunscreenGiveawayBanner =
    Boolean(useFlag('curology-sunscreen-giveaway')) &&
    CONFIG.isCurologyApp &&
    offerCategory === OFFER_CATEGORIES.freeTrial;

  if (!showSunscreenGiveawayBanner) {
    return null;
  }

  return (
    <div data-test-id="sunscreen-giveaway" css={sunscreenGiveawayBannerStyles}>
      Say hello to summer{' '}
      <span role="img" aria-label="Sun">
        ☀️
      </span>{' '}
      Get a FREE sunscreen in your first box! While supplies last.
    </div>
  );
};

export default SunscreenGiveawayBanner;
